export default {
  model () {
    return {
      tyres: 1,
      codes: []
    }
  },
  rules (model) {
    return {
      tyres: [
        {required: true, message: 'Las llantas vendidas son requeridas', trigger: 'change'}
      ],
      codes: [
        {required: true, message: 'El código es requerido', trigger: 'blur'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/codes.model.js